<template>
    <div class="auth container-fluid">
        <div class="row justify-content-center">
            <div class="col-xl-7  col-lg-8 col-md-10 col-sm-12">
                <div class="locale_block login_page">
                    <locale-button class="locale_block__button--first" language="nl"/>
                    <locale-button class="locale_block__button" language="fr"/>
                </div>
                <div class="block--auth has-no-top-margin">
                    <img class="logo" src="/static/img/logo_minimax.png" alt="Minimax Client Dashboard" title="Minimax Client Dashboard" height="32px">
                    <p v-if="!newPasswordSent">{{ $t('form.password_forgotten.message_forgotten_password') }}</p>
                    <transition name="fade" mode="out-in">
                        <div v-if="newPasswordSent">
                            <h2>{{$t('form.password_forgotten.header_request_success')}}</h2>
                            <p>{{$t('form.password_forgotten.message_success', {email})}}</p>
                            <router-link :to="{ name: 'sign-in'}" type="button" class="button">
                                {{$t('common.button.go_back')}}
                            </router-link>
                        </div>
                        <form v-else class="form" @submit.prevent="request">
                            <h1>{{$t('form.password_forgotten.header_main')}}</h1>
                            <div class="form__group">
                                <i class="form__input__icon mdi mdi-email-outline"></i>
                                <input class="form__input--text underline has-icon"
                                       type="email"
                                       required
                                       name="email"
                                       autocomplete="email"
                                       v-model="email"
                                       :placeholder="$t('auth.hint_email')"
                                />
                            </div>
                            <div class="form__buttons">
                                <div class="row">
                                    <div class="col-12 col-md-4 col-lg-5 order-md-first">
                                        <router-link class="button full-width is-forgot-password" :to="{name: 'sign-in'}">
                                            {{$t('common.button.go_back')}}
                                        </router-link>
                                    </div>
                                    <div class="col-12 col-md-8 col-lg-7 order-first">
                                        <button type="submit"
                                                class="button--cta full-width is-forgot-password"
                                                :disabled="busy"
                                                :class="{'is-loading': busy}">
                                            {{ $t('form.password_forgotten.button_submit') }}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </transition>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    /* eslint-disable indent */

    import Vue from 'vue';
    import {Component} from 'vue-property-decorator';
    import LocaleButton from '../../general/LocaleButton';
    import { REQUEST_NEW_PASSWORD} from '../../../store/modules/auth';

    @Component({
        components: {LocaleButton}
    })
    export default class PasswordForgottenForm extends Vue {
        name = 'password-forgotten-form';
        newPasswordSent = false;
        busy = false;
        email = '';
        error = '';

        /**
         * Request a new password
         */
        async request() {
            this.busy = true;
            const payload = {email: this.email};
            try {
                await this.$store.dispatch(REQUEST_NEW_PASSWORD, payload);
                this.$notify.success(this.$t('form.password_forgotten.header_request_success'));
                this.newPasswordSent = true;
            } catch (e){
                console.log(e);
                if (e.response && e.response.data && e.response.data.errors) {
                    const data = e.response.data;
                    this.error = data.errors;
                } else {
                    this.error = this.$t('form.password_forgotten.message_failure');
                }
                this.$notify.error(this.error);
            } finally {
                this.busy = false;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/auth/forms/PasswordForgottenForm.vue